import { render, staticRenderFns } from "./GraficosComponent.vue?vue&type=template&id=63ccd963&scoped=true"
import script from "./GraficosComponent.vue?vue&type=script&lang=js"
export * from "./GraficosComponent.vue?vue&type=script&lang=js"
import style0 from "./GraficosComponent.vue?vue&type=style&index=0&id=63ccd963&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ccd963",
  null
  
)

export default component.exports